import { gql } from '@apollo/client';

export const GetSitePasFindsQueryName = 'GetSitePasFinds';

export const PAS_FIND_FRAGMENT = gql`
  fragment PasFindFields on Find {
    id
    evId
    siteId
    groupIds
    tags
    description
    foundAt
    material
    era
    type
    localization
    latitude
    longitude
    depth
    count
    situationType
    foundBy
    visibility
    image
    images
    amcrId
    amcrStatus
    amcrData(cacheOnly: true) {
      images
      files {
        id
        name
        sha512
        uploadedName
      }
    }
  }
`;

export const GET_SITE_PAS_FINDS_QUERY = gql`
  query ${GetSitePasFindsQueryName}($siteId: String!, $filters: Filters) {
    getSiteFinds(siteId: $siteId, filters: $filters) {
      ...PasFindFields
    }
  }
  ${PAS_FIND_FRAGMENT}
`;
